import React, { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Input from "../input";
import DropdownComp from "../dropdown";
import ButtonContained from "../button";
import { EditProductSchema } from "../../validation/ValidationSchema";
import { api } from "../../api";
import { setSwitchRegion } from "../../redux/authSlice";

import { toast } from "react-toastify";
import {
  getMasterProductsList,
  getEzPinProductsList,
  getGenbaProductsList,
  getGenbaProductPriceList,
  getAppIdForGenbaProductName,
} from "../../helpers/listsApi";

import Loader from "../loader/Loader";

const EditProduct = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const region = useSelector((state) => state.auth.region);
  // eslint-disable-next-line
  const { userType: role } = useSelector((state) => state.auth.user);

  const [apiAccess, setApiAccess] = useState(false);
  const checkApiAccess = (e) => {
    setApiAccess(e.target.checked);
  };
  const id = useParams().id;
  const [product, setProduct] = useState({});
  const [masterDataList, setMasterDataList] = useState([
    { value: "", label: "please select" },
  ]);
  // eslint-disable-next-line no-unused-vars
  const [genbaProductId, setGenbaAppId] = useState([{}]);

  //loading
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [genbaData, setGenbaData] = useState([]);
  const [currentProduct, setCurrentProduct] = useState({});
  // eslint-disable-next-line no-unused-vars
  const [currentGenba, setCurrentGenba] = useState({});

  useEffect(() => {
    dispatch(setSwitchRegion(false));

    return () => {
      dispatch(setSwitchRegion(true)); // reset when unmounting
    };
  }, [dispatch]);

  useEffect(() => {
    api.products.getProductById({ productId: id }, token).then((res) => {
      if (res.code === 200) {
        setProduct(res.data);
      } else {
        toast.error(res.message);
        navigate("/products-denomination");
      }
    });
    // eslint-disable-next-line
  }, [token, id]);

  useEffect(
    (_) => {
      setApiAccess(product.productApiAccess ? product.productApiAccess : false);
    },
    [product]
  );

  useEffect(
    (_) => {
      getAppIdForGenbaProductName(currentProduct.value)
        .then((res) => Object.keys(currentProduct).length && setGenbaAppId(res))
        .catch((err) => console.log(err, " err"));
    },
    [currentProduct]
  );

  useEffect(() => {
    getEzPinProductsList({
      limit: 150,
      offset: 1,
    }).then((res) => {
      setData(res);
    });
  }, []);

  useEffect(() => {
    getGenbaProductsList({}, token).then((res) => {
      setGenbaData(res);
    });
  }, [token]);

  useEffect(
    (_) => {
      getMasterProductsList(product.brand ? product.brand.brandId : "", token)
        .then((res) => Object.keys(product).length && setMasterDataList(res))
        .catch((err) => console.log(err, " err"));
    },
    [product, token]
  );

  const getGenbaPriceValue = async (selectedValue) => {
    let result = await getGenbaProductPriceList(selectedValue?.sku, token);

    return filterINRCurrencyData(result);
    // return result;
  };

  const getGenbaProductName = async (selectedValue) => {
    let result = await getAppIdForGenbaProductName(selectedValue?.name, token);

    return result;
  };

  const filterINRCurrencyData = (value) => {
    return value && value.filter((data) => data.currencycode === "INR");
  };

  return (
    <Formik
      validationSchema={EditProductSchema}
      enableReinitialize
      initialValues={{
        productBrand: product.brand ? product.brand.brandName : "",
        price: product.productPrice || "",
        margin: product.productMargin || "",
        productDenomination: product.productDenomination || "",
        denominationAmt: "",
        productName: product.productName || "",
        trashHold: product.productThreshold || "",
        master:
          product.masterProductIds &&
          product.masterProductIds.map((item) => {
            return { value: item.masterProductId, label: item.name };
          }),
        genbaSteamAppId: product.genbaSteamAppId,
        genbaCutOffPrice: product.genbaCutOffPrice || "",
        purhaseAmt: "",
        batchNumber: "",
        token: "",
        autharizationCode: "",
        ProductKey: "",
        ProductKeyBase64: "",
        sku: product.sku || "",
        isDevco: product.isDevco || false,
        devcoProductId: product.devcoProductId || "",
        isEpay: product.isEpay || false,
        epayProductId: product.epayProductId || "",
        epayBillerId: product.epayBillerId || "",
      }}
      onSubmit={(values, { resetForm }) => {
        const masterArr = values.master.map((mr) => mr.value);
        setIsLoading(true);
        const formBody = {
          productId: product.productId,
          productName: values.productName,
          productBrandId: product.brand.brandId,
          productPrice: values.price,
          genbaCutOffPrice: values.genbaCutOffPrice,
          genbaSteamAppId: values.genbaSteamAppId,
          productApiAccess: apiAccess,
          productThreshold: values.trashHold,
          productMargin: values.margin,
          productDenomination: values.productDenomination,
          masterProductIds: masterArr,
          productsku: values.sku,
          isDevco: values.isDevco,
          devcoProductId: values.devcoProductId,
          isEpay: values.isEpay,
          epayProductId: values.epayProductId,
          epayBillerId: values.epayBillerId,
        };

        api.products
          .updateProductById(formBody, token)
          .then((res) => {
            if (res.code === 200) {
              resetForm();
              setIsLoading(false);
              toast.success("Product updated successfully");
              navigate("/products-denomination");
            } else {
              resetForm();
              setIsLoading(false);
              toast.error("Something went wrong");
            }
          })
          .catch((err) => {
            resetForm();
            setIsLoading(false);
            toast.error("Something went wrong");
            navigate("/products-denomination");
          });
      }}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
        isSubmitting,
        setFieldValue,
      }) => {
        const ge = values && values.productBrand === "Genba";
        const ez = values && values.productBrand === "EZ PIN";
        return (
          <div className="container-fluid">
            {/* <section className="mt-4"> */}
            <div className="row">
              <div className="col-sm-12">
                <div className="box-row">
                  <div className="table-head">
                    <h1 className="sec-header">EDIT PRODUCT</h1>
                  </div>
                  <div className="card card-table">
                    <div className="card-body gatepass-saveoutput">
                      <div className="reports">
                        <Form onSubmit={handleSubmit}>
                          <div className="form-row">
                            <div
                              className={`form-group col-md-${
                                ez || ge ? `3` : `4`
                              }`}
                            >
                              <Input
                                id="productBrand"
                                readOnly
                                name="productBrand"
                                placeholder="Brand"
                                // type="text"
                                label="Brand"
                                value={values.productBrand}
                                onChange={handleChange}
                                disabled={isSubmitting}
                              />
                            </div>
                            {ez && (
                              <div className="form-group col-md-3">
                                <DropdownComp
                                  id="ezPinProducts"
                                  name="ezPinProducts"
                                  onChange={(selectedValue) => {
                                    setFieldValue(
                                      "ezPinProducts",
                                      selectedValue
                                    );
                                    setFieldValue(
                                      "productName",
                                      selectedValue.value
                                    );
                                    setFieldValue(
                                      "price",
                                      selectedValue.min_price ===
                                        selectedValue.max_price
                                        ? selectedValue.max_price
                                        : ""
                                    );
                                    setFieldValue(
                                      "sku",
                                      `EZ_${selectedValue.sku}_${selectedValue.currency}_${selectedValue.max_price}`
                                    );
                                  }}
                                  value={values.ezPinProducts}
                                  options={data}
                                  label="EZ PIN Products"
                                  placeholder="EZ PIN Products"
                                  error={
                                    touched.ezPinProducts &&
                                    errors.ezPinProducts
                                  }
                                  errorText={errors.ezPinProducts}
                                  disabled={isSubmitting}
                                />
                              </div>
                            )}
                            {ge && (
                              <div className="form-group col-md-3">
                                <DropdownComp
                                  id="genbaProducts"
                                  name="genbaProducts"
                                  onChange={async (selectedValue) => {
                                    setCurrentGenba(
                                      getGenbaPriceValue(selectedValue)
                                    );
                                    let result = await getGenbaPriceValue(
                                      selectedValue
                                    );
                                    setFieldValue(
                                      "genbaProducts",
                                      selectedValue
                                    );
                                    setFieldValue(
                                      "productName",
                                      selectedValue.value
                                    );
                                    setFieldValue("price", result[0]?.srp);
                                    setFieldValue(
                                      "sku",
                                      `GENBA_${selectedValue.sku}`
                                    );
                                    // setCurrentProduct(selectedValue)
                                    setCurrentProduct(
                                      getGenbaProductName(selectedValue)
                                    );
                                    let resultt = await getGenbaProductName(
                                      selectedValue
                                    );
                                    setFieldValue(
                                      "genbaSteamAppId",
                                      resultt[0]?.value
                                    );
                                  }}
                                  value={values.genbaProducts}
                                  options={genbaData}
                                  label="GENBA Products"
                                  placeholder="GENBA Products"
                                  error={
                                    touched.genbaProducts &&
                                    errors.genbaProducts
                                  }
                                  errorText={errors.genbaProducts}
                                  disabled={isSubmitting}
                                />
                              </div>
                            )}
                            <div
                              className={`form-group col-md-${
                                ez || ge ? `3` : `4`
                              }`}
                            >
                              <Input
                                id="margin"
                                name="margin"
                                placeholder="Nodwin Margin"
                                type="number"
                                label="Nodwin Margin"
                                value={values.margin}
                                onChange={handleChange}
                                error={touched.margin && errors.margin}
                                errorText={errors.margin}
                                percentage={true}
                                disabled={isSubmitting}
                              />
                            </div>
                            <div
                              className={`form-group col-md-${
                                ez || ge ? `3` : `4`
                              }`}
                            >
                              <Input
                                id="trashHold"
                                name="trashHold"
                                placeholder="Minimum Quantity"
                                type="number"
                                label="Minimum Quantity"
                                value={values.trashHold}
                                onChange={handleChange}
                                error={touched.trashHold && errors.trashHold}
                                errorText={errors.trashHold}
                                disabled={isSubmitting}
                              />
                            </div>
                          </div>
                          <div className="form-row">
                            <div
                              className={`form-group col-md-${
                                ez || ge ? `3` : `4`
                              }`}
                            >
                              <Input
                                id="productName"
                                name="productName"
                                placeholder="Product Denomination"
                                type="text"
                                label="Product Denomination"
                                value={values.productName}
                                onChange={handleChange}
                                error={
                                  touched.productName && errors.productName
                                }
                                errorText={errors.productName}
                                disabled={isSubmitting}
                              />
                            </div>
                            <div
                              className={`form-group col-md-${
                                ez || ge ? `3` : `4`
                              }`}
                            >
                              <Input
                                id="price"
                                name="price"
                                placeholder="Product Denomination Amount"
                                type="number"
                                label="Product Denomination Amount"
                                value={values.price}
                                onChange={handleChange}
                                error={touched.price && errors.price}
                                errorText={errors.price}
                                disabled={isSubmitting}
                              />
                            </div>
                            <div
                              hidden={!ge}
                              className={`form-group col-md-${ge ? `3` : `4`}`}
                            >
                              <Input
                                id="genbaCutOffPrice"
                                name="genbaCutOffPrice"
                                placeholder="Product Cut Off Amount"
                                type="number"
                                label="Product Cut Off Amount"
                                value={values.genbaCutOffPrice}
                                onChange={handleChange}
                                error={
                                  touched.genbaCutOffPrice &&
                                  errors.genbaCutOffPrice
                                }
                                errorText={errors.genbaCutOffPrice}
                                disabled={isSubmitting}
                              />
                            </div>
                            <div
                              hidden={!ge}
                              className={`form-group col-md-${ge ? `3` : `4`}`}
                            >
                              <Input
                                readOnly
                                id="genbaSteamAppId"
                                name="genbaSteamAppId"
                                placeholder="Steam App Id"
                                type="number"
                                label="Steam App Id"
                                value={values.genbaSteamAppId}
                                onChange={handleChange}
                                error={
                                  touched.genbaSteamAppId &&
                                  errors.genbaSteamAppId
                                }
                                errorText={errors.genbaSteamAppId}
                                disabled={isSubmitting}
                              />
                            </div>
                            <div
                              className={`form-group col-md-${
                                ez || ge ? `3` : `4`
                              }`}
                            >
                              <DropdownComp
                                id="master"
                                name="master"
                                placeholder="Master product"
                                label="Master Product"
                                value={values.master}
                                isMulti
                                onChange={(selectedValue) => {
                                  setFieldValue("master", selectedValue);
                                }}
                                options={masterDataList}
                                error={touched.master && errors.master}
                                errorText={errors.master}
                                disabled={isSubmitting}
                              />
                            </div>
                            <div
                              hidden={!ez}
                              className={`form-group col-md-${ez ? `3` : `4`}`}
                            >
                              <Input
                                readOnly
                                id="sku"
                                name="sku"
                                placeholder="Product SKU"
                                type="text"
                                label="Product SKU"
                                value={ez && values.sku}
                                onChange={handleChange}
                                error={touched.sku && errors.sku}
                                errorText={errors.sku}
                                disabled={isSubmitting}
                              />
                            </div>
                            <div
                              hidden={!ge}
                              className={`form-group col-md-${ez ? `3` : `4`}`}
                            >
                              <Input
                                readOnly
                                id="sku"
                                name="sku"
                                placeholder="Product SKU"
                                type="text"
                                label="Product SKU"
                                value={ge && values.sku}
                                onChange={handleChange}
                                error={touched.sku && errors.sku}
                                errorText={errors.sku}
                                disabled={isSubmitting}
                              />
                            </div>
                          </div>

                          <div hidden={ez || ge} className="form-row">
                            <div
                              className={`form-group col-md-${
                                ez || ge ? `3` : `4`
                              }`}
                            >
                              <Input
                                id="sku"
                                name="sku"
                                placeholder="Product SKU"
                                type="text"
                                label="Product SKU"
                                value={values.sku}
                                onChange={handleChange}
                                error={touched.sku && errors.sku}
                                errorText={errors.sku}
                                disabled={isSubmitting}
                              />
                            </div>
                          </div>

                          <div className="form-row">
                              <div className="form-group col-md-6">
                                <label className="form-label">
                                  Product Source
                                </label>

                                {/* DEVCO */}
                                {region.currency === "USD" && (
                                  <div className="form-check mb-2">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="isDevco"
                                      name="isDevco"
                                      checked={values.isDevco}
                                      onChange={(e) => {
                                        const checked = e.target.checked;
                                        setFieldValue("isDevco", checked);
                                        if (checked) {
                                          setFieldValue("isEpay", false);
                                          setFieldValue("epayProductId", "");
                                          setFieldValue("epayBillerId", "");
                                        }
                                        if (!checked) {
                                          setFieldValue("devcoProductId", "");
                                        }
                                      }}
                                      disabled={isSubmitting || values.isEpay}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="isDevco"
                                    >
                                      Devco
                                    </label>
                                  </div>
                                )}

                                {/* EPAY */}
                                <div className="form-check">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="isEpay"
                                    name="isEpay"
                                    checked={values.isEpay}
                                    onChange={(e) => {
                                      const checked = e.target.checked;
                                      setFieldValue("isEpay", checked);
                                      if (checked) {
                                        setFieldValue("isDevco", false);
                                        setFieldValue("devcoProductId", "");
                                      }
                                      if (!checked) {
                                        setFieldValue("epayProductId", "");
                                        setFieldValue("epayBillerId", "");
                                      }
                                    }}
                                    disabled={isSubmitting || values.isDevco}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="isEpay"
                                  >
                                    Epay
                                  </label>
                                </div>
                              </div>

                              {/* DEVCO PRODUCT ID */}
                              {region.currency === "USD" && values.isDevco && (
                                <div className="form-group col-md-6">
                                  <Input
                                    id="devcoProductId"
                                    name="devcoProductId"
                                    placeholder="Devco Product ID"
                                    type="text"
                                    label="Devco Product ID"
                                    value={values.devcoProductId}
                                    onChange={handleChange}
                                    error={
                                      touched.devcoProductId &&
                                      errors.devcoProductId
                                    }
                                    errorText={errors.devcoProductId}
                                    disabled={isSubmitting}
                                  />
                                </div>
                              )}

                              {/* EPAY PRODUCT ID + BILLER ID */}
                              {values.isEpay && (
                                <div className="form-group col-md-6">
                                  <Input
                                    id="epayProductId"
                                    name="epayProductId"
                                    placeholder="Epay Product ID"
                                    type="text"
                                    label="Epay Product ID"
                                    value={values.epayProductId}
                                    onChange={handleChange}
                                    error={
                                      touched.epayProductId &&
                                      errors.epayProductId
                                    }
                                    errorText={errors.epayProductId}
                                    disabled={isSubmitting}
                                  />
                                  <Input
                                    id="epayBillerId"
                                    name="epayBillerId"
                                    placeholder="Epay Biller ID"
                                    type="text"
                                    label="Epay Biller ID"
                                    value={values.epayBillerId}
                                    onChange={handleChange}
                                    error={
                                      touched.epayBillerId &&
                                      errors.epayBillerId
                                    }
                                    errorText={errors.epayBillerId}
                                    disabled={isSubmitting}
                                  />
                                </div>
                              )}
                            </div>

                          <div className="form-row">
                            <div className="form-group col-md-4">
                              <label htmlFor="customCheck">Alert </label>
                              <br />
                              <div className="custom-control custom-checkbox mb-3 mt-3">
                                <input
                                  onChange={checkApiAccess}
                                  value={apiAccess}
                                  checked={apiAccess}
                                  style={{ zIndex: "100" }}
                                  type="checkbox"
                                  className="custom-control-input"
                                  id="customCheck"
                                  name="example1"
                                  disabled={isSubmitting}
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor="customCheck"
                                >
                                  {" "}
                                  API Access
                                </label>
                              </div>
                            </div>
                          </div>

                          <ButtonContained
                            buttonName="Update"
                            disabled={isSubmitting}
                            loading={isLoading}
                          >
                            <Loader />
                          </ButtonContained>
                        </Form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* </section> */}
          </div>
        );
      }}
    </Formik>
  );
};

export default EditProduct;
